import { apiFetch } from './utils/api';

export const cashFlowEvents = {
  get: async () => {
    const options = {
      method: 'GET',
    };

    const url = '/v3/wealth-plan/cash-flow-events';
    const { body } = await apiFetch(url, {
      ...options,
    });

    return body;
  },
};
